import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUser, logout, checkAuthState } from './authSlice';
import {
  selectAuthState,
  selectUser,
  selectIsUserLogin,
  selectUserEmail,
  selectIsAuthenticated
} from './authSelectors';
import { auth } from '../../firebase/firebase';
import { onAuthStateChanged } from 'firebase/auth';

export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (!firebaseUser?.uid) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      const adminUids = [
        "IYlBFmEgMiarQ4p5B7OKfefH3DO2",
        "anzHKVkexIZx0oakVGcty3oqw4j1"
      ];

      const isUserAdmin = adminUids.includes(firebaseUser.uid);
      setIsAdmin(isUserAdmin);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { isAdmin, loading };
};

export const useAuth = () => {
  const dispatch = useDispatch();

  const authState = useSelector(selectAuthState);
  const user = useSelector(selectUser);
  const isUserLogin = useSelector(selectIsUserLogin);
  const userEmail = useSelector(selectUserEmail);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const setAuthUser = (userData: { email?: string; name?: string; picture?: string; sub?: string } | null) => dispatch(setUser(userData));
  const logoutUser = () => dispatch(logout());
  const checkAuth = () => dispatch(checkAuthState());

  return {
    state: { auth: authState },
    auth: authState,
    user,
    isUserLogin,
    userEmail,
    isAuthenticated,
    setUser: setAuthUser,
    logout: logoutUser,
    checkAuthState: checkAuth,
  };
};
